/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { Pages } from 'pages/pages';
import { APPLICATIONS_PAGE_TITLE } from 'common/constants';
import { ContactsMenuModal} from "../Modals/ContactsMenu/ContactsMenuModal";
import { CustomerPermission, InitContextProps, isAccessibleForRoles, RegisterData, useAuthContext } from "../../services/context/authentication.context";
import { MobileMenu } from "../MobileMenu/MobileMenu";
import AuthenticationService from "../../services/authentication.service";
import CustomerContactService from 'services/customer-contact.service';
import { UserContact } from 'models/user-contact';
import { mapUserContactToCustomer, userService } from 'services/user.service';
import RoleSelectModal from 'components/Modals/RoleSelectModal/RoleSelectModal';
import CompanyService from 'services/company.service';
import { Company } from 'models/company';
import { LOCAL_STORAGE_KEYS } from 'common/constants/localStorageKeys';
import { AS_CUSTOMER_PATH } from 'App';

const HOME_PATH = '/esileht';
const REGISTER_PATH = 'registreeri';

export function Header(props: { utilityPageState: boolean }) {
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [isContactsMenuVisible, setContactsMenu] = useState(false);
    const [isRoleSelectModalVisible, setRoleSelectModalVisible] = useState(false);
    const [userContacts, setUserContacts] = useState<UserContact[]>([]);
    const [userContactsLoading, setUserContactsLoading] = useState(true);
    const [companies, setCompanies] = useState<Company[]>([]);
    const [currentRoute, setCurrentRoute] = useState<string | undefined>();

    const { state, dispatch, hasPermission }: InitContextProps = useAuthContext();
    const {customerId, customer} = state;
    let history = useHistory();

    const isAsCustomerLoaderActive = window.location.href.indexOf(AS_CUSTOMER_PATH) !== -1;

    useEffect(() => {
        if (state.user && state.registerData) {
            history.push('/' + REGISTER_PATH);
            hideContactsMenu();
            setRoleSelectModalVisible(false);
        }
    }, [state.registerData]);

    useEffect(() => {
        if (history.location.pathname === HOME_PATH && currentRoute && currentRoute !== history.location.pathname && !!state.userId && !isAsCustomerLoaderActive) {
            fetchContacts(state.userId, true);
        }
        setCurrentRoute(history.location.pathname);
    }, [history.location.pathname]);

    useEffect(() => {
        const userId = state.userId;
        if (state.authenticated && userId) {
            userService.getUserInfo().then(res => {
                localStorage.setItem(LOCAL_STORAGE_KEYS.USER, JSON.stringify(res));
                dispatch({
                    type: "setUser",
                    value: res
                });
                if(!isAsCustomerLoaderActive){
                    fetchContacts(userId, history.location.pathname === HOME_PATH);
                }
            });            
            CompanyService.getCompanies(state.userId).then(res => setCompanies(res));
        }
    }, [state.authenticated, customerId, state.userId]);

    useEffect(() => {
         setInitialCustomer();
    }, [userContacts, userContactsLoading, state.customerId, companies])
    
    const showContactsMenu = () => setContactsMenu(true);
    const hideContactsMenu = () => setContactsMenu(false);
    const logoutUser = () => {
        setContactsMenu(false);
        AuthenticationService.logout();
        // history.push("login");
        dispatch({
            type: "setAuthenticated",
            value: false
        });

    };
    const toggleMobileMenu = () => setMobileMenuOpen(!isMobileMenuOpen);

    const handlePrivateCustomerChange = (customerId: number) => {
        localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
        window.location.replace(`${process.env.REACT_APP_PRIVATE_URL}${AS_CUSTOMER_PATH}?id=${customerId}`);    
    }

    const handleCustomerChange = async (selectedCustomerId: number, isPerson: boolean) => {
        if(isPerson){
            handlePrivateCustomerChange(selectedCustomerId);
            return;
        }

        localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID, selectedCustomerId + '');
        dispatch({
            type: "setCustomerId",
            value: selectedCustomerId
        });
        const asCustomer = userContacts?.find(contact => contact.customerId === selectedCustomerId);
        if (asCustomer) {
            dispatch({
                type: "setCustomer",
                value: mapUserContactToCustomer(asCustomer)
            });
            dispatch({
                type: "setAuthenticated",
                value: true
            });
        }
        hideContactsMenu();
        setRoleSelectModalVisible(false);
    };

    const handleRegisterClick = (isCompany: boolean, company?: Company): void => {
        if (history.location.pathname.indexOf(REGISTER_PATH) !== -1 && !!state.registerData &&
            state.registerData.isCompany === isCompany && state.registerData.companyId === company?.id
        ) {
            return;
        }

        const value: RegisterData = {
            isCompany
        };

        if (isCompany && company) {
            value.companyId = company.id;
            value.registryNumber = company.registryNumber;
            value.vatRegistryNumber = company.vatRegistryNumber;
            value.name = company.name;
            value.customerId = company.customerId
        }

        dispatch({
            type: 'setRegisterData',
            value
        });
    }

    const fetchContacts = async (userId: number, withSync = false) => {
        setUserContactsLoading(true);

        let contacts = await CustomerContactService.getUserContacts(userId) as UserContact[];

        let current = contacts.find(contact => contact.customerId === customerId);
        if (current) {
            if (current.isPerson) {
                handlePrivateCustomerChange(current.customerId)
            }

            if (withSync) {
                const syncedContact = await CustomerContactService.getCurrentUserContactWithSync(userId, current.id) as UserContact;
                contacts = contacts.map(c => c.id === syncedContact.id ? { ...syncedContact, active: true } : c);
                current = syncedContact;
            }

            current.active = true;

            dispatch({
                type: "setCustomer",
                value: mapUserContactToCustomer(current)
            });
            
        } else {
            localStorage.removeItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID);
        }
        setUserContacts(contacts);
        setUserContactsLoading(false);
    }

    const setInitialCustomer = async () => {

        let lastUsedCustomer = userContacts?.find(c => c.customerId === customerId);

        if (userContacts.length && ((userContacts.length === 1 && (!companies.length || userContacts[0].registryNumber === state.user?.personalIdentificationCode)) || state.customerId)) {
            if (!lastUsedCustomer) {
                let firstContact = userContacts[0];
                firstContact = await CustomerContactService.getCurrentUserContactWithSync(state.userId, firstContact.id);

                if (customerId === null && firstContact.customerId !== null) {
                    localStorage.setItem(LOCAL_STORAGE_KEYS.CUSTOMER_ID, firstContact.customerId + '');
                    dispatch({
                        type: "setCustomerId",
                        value: firstContact.customerId
                    });
                    dispatch({
                        type: "setCustomer",
                        value: mapUserContactToCustomer(firstContact)
                    });
                    dispatch({
                        type: "setAuthenticated",
                        value: true
                    });
                }
            } else if (lastUsedCustomer && !customer && dispatch) {
                const updatedCustomer = await CustomerContactService.getCurrentUserContactWithSync(state.userId, lastUsedCustomer.id);

                dispatch({
                    type: "setCustomer",
                    value: mapUserContactToCustomer(updatedCustomer)
                });
                dispatch({
                    type: "setAuthenticated",
                    value: true
                });
            }
        } else if (!userContactsLoading && !state.customerId && (userContacts.length || companies.length) && !isRoleSelectModalVisible && !history.location.pathname.includes(REGISTER_PATH)) {
            setRoleSelectModalVisible(true);
            dispatch({
                type: "setAuthenticated",
                value: true
            });
        } else if (!userContactsLoading && !state.customerId && !userContacts.length && !companies.length) {
            handleRegisterClick(false);
        }
    }

    const checkIfUtility = () => {
        const activeCustomerName = customer?.name;

        if (props.utilityPageState) {
            return (
                <a
                    className='d-flex justify-content-end text-primary mr-xl-5 line-height-1 mt-2'
                    href='https://www.terminalenergia.ee/'
                    target='_blank'
                    rel="noopener noreferrer">
                    <div className='d-flex align-items-center'>
                        Terminali kodulehele
                        <div className='ml-1'>
                        </div>
                        <div className='icon--16 icon__external-link'/>
                    </div>
                </a>
            )
        } else {
            return (
                <div className="d-flex flex-row flex-wrap justify-content-end align-items-center">
                    <button
                        type='button'
                        className='btn btn-primary d-flex d-lg-none align-items-center'
                        onClick={toggleMobileMenu}
                    >
                        <i className="icon--16 icon__mobile-menu" />
                    </button>
                    <div className='d-flex align-items-center d-lg-none mx-1'>
                        <div className='border-left border-success pt-3' />
                    </div>
                    <a role='button' onClick={showContactsMenu} className={"p-0 text-white contacts-button"}>
                        <div className="d-flex d-lg-none align-items-center">
                            <i className='icon--16 icon__switch' />
                            <span className="mobile-role-name ml-2">{activeCustomerName}</span>
                        </div>
                        <span className="ml-2 d-none d-lg-flex align-items-center">
                            {activeCustomerName || '...'}
                            <i className='icon__chevron-down'></i>
                        </span>
                    </a>
                    <RoleSelectModal
                        visible={isRoleSelectModalVisible}
                        contacts={userContacts}
                        hasActiveCustomer={!!activeCustomerName}
                        onHide={() => setRoleSelectModalVisible(false)}
                        onCustomerChange={handleCustomerChange}
                        onRegister={handleRegisterClick}
                        companies={companies}
                    />
                    <ContactsMenuModal
                        isVisible={isContactsMenuVisible}
                        userContacts={userContacts}
                        companies={companies}
                        hasActiveCustomer={!!activeCustomerName}
                        handleMenuHide={hideContactsMenu}
                        handleMenuLogout={logoutUser}
                        handleCustomerChange={handleCustomerChange}
                        onRegister={handleRegisterClick}
                    />

                </div>
            )}
    };

    const navStyles = 'd-none d-lg-block col';
    const accessiblePages = Pages
        .filter(page => isAccessibleForRoles(page.requiredRoles, state.customer))
        .filter(page => !page.onlyShowForPersons || (state.customer && state.customer.isPerson))
        .filter(page => !page.onlyShowForCompany || (state.customer && !state.customer.isPerson))
        .filter(page => !page.mustHaveGroupId || (state.customer && page.mustHaveGroupId.includes(state.customer.groupId)))
        .filter(page => page.title !== APPLICATIONS_PAGE_TITLE || state.customer.hasApplications)
        .filter(page => !page.onlyShowForRepresentative || hasPermission(CustomerPermission.REPRESENTATIVE));

    const populateNav = accessiblePages.filter((page) => page.showInNav).map((page) =>
        <li key={page.title} className="px-1 px-xl-3">
            <NavLink
                to={`/${page.title}`}
                className='text-white text-capitalize text-decoration-none'
                activeClassName='active'>
                {page.title}
            </NavLink>
        </li>);

    return (
        <header
            className={props.utilityPageState ? 'container-fluid utilityPage' : 'container-fluid'}
        >
            <div className="row w-100">
                <div className="header__logo col-sm ml-xl-5 w-8-rem cursor-pointer header-side-container"
                     onClick={(() => {
                         if (history.location.pathname !== '/login') {
                             history.push("/");
                         }
                     })}/>
                <nav className={navStyles}>
                    <ul className={props.utilityPageState ? 'd-none' : 'nav d-flex justify-content-center'}>
                        {state.authenticated && !state.customer ? null : (
                          <>{populateNav}</>
                        )}
                    </ul>
                </nav>
                <div className='col mx-n2 mx-sm-0 px-0 px-sm-3 header-side-container'>
                    {checkIfUtility()}
                </div>
            </div>
            <MobileMenu
                isOpen={isMobileMenuOpen}
                action={toggleMobileMenu}
            />
        </header>
    )
}
